import { forwardRef, useState, useEffect, useImperativeHandle, useRef } from 'react';
import styled from "styled-components"
import { useForm, useFieldArray, useWatch } from "react-hook-form"
import { z } from 'zod'
import { zodResolver } from "@hookform/resolvers/zod"
import {
    Form,
    FormControl,
    FormDescription,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "../../../ui/form"

import { Checkbox, Button } from "../../../ui/ot"
import ReactHtmlParser from 'react-html-parser';

const PatronPermissionForm = forwardRef(({
    onFormFinish = () => { },
}, ref) => {
    const thisJS = "PatronPermissionForm"
    const formRef = useRef()

    const xPermission = z.object({
        "module_bit": z.number(),
        "allow_code": z.number(),
        "code": z.string(),
        "description": z.string(),
    });
    const xUserflags = z.object({
        "bit": z.number(),
        "allow_flag": z.number(),
        "flag": z.string(),
        "flagdesc": z.string(),
        "permissions": z.array(xPermission),
        "expanded": z.number(),
    });
    const formSchema = z.object({
        "borrowernumber": z.string(),
        "userflags": z.array(xUserflags)
    });
    const form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
        },
    })
    const CheckBoxAllowFlag = ({ control, field, index, register }) => {
        return (
            <Checkbox
                style={{ "marginLeft": "3px"}}
                checked={field.value === 1}
                onCheckedChange={(checked) => {
                    const allow_flag = checked ? 1 : 0
                    if (index === 0) {
                        const userflags = form.getValues(`userflags`)
                        userflags.forEach((oUserflag, i) => {
                            if (oUserflag.allow_flag !== allow_flag) {
                                form.setValue(`userflags.${i}.allow_flag`, allow_flag)
                            }
                            oUserflag.permissions.forEach((permission, j) => {
                                if (permission.allow_code !== allow_flag) {
                                    form.setValue(`userflags.${i}.permissions.${j}.allow_code`, allow_flag)
                                }
							})
                        })
                    } else {
                        const oUserflag = form.getValues(`userflags.${index}`)
                        oUserflag.permissions.forEach((permission, i) => {
                            const allow_code = form.getValues(`userflags.${index}.permissions.${i}.allow_code`)
                            if (allow_code !== allow_flag) {
                                form.setValue(`userflags.${index}.permissions.${i}.allow_code`, allow_flag)
                            }
                        })
                    }
                    return field.onChange(allow_flag)
                }}
            />
        )
    }
    const ButtonToggle = ({ control, field, index, register }) => {
        const userflags = useWatch({
            control,
            name: "userflags",
        })
        let oUserflag = userflags[index]
        if (oUserflag?.permissions.length > 0) {
            return (
                <Button style={{ "background": "none", "border": "none", "color": "green" }}
                    onClick={() => { return field.value === 1 ? field.onChange(0) : field.onChange(1) }}>
                    {field.value === 1 ? '隱藏詳情' : '顯示詳情'}
                </Button>
            )
        } else {
            return (<></>)
        }
    }
    const SubPermissions = ({ control, field, index, register }) => {
        const userflags = useWatch({
            control,
            name: "userflags",
        })
        let oUserflag = userflags[index]
        if (oUserflag?.expanded === 1) {
            return (<SubPermissionsContainer>
                {oUserflag.permissions.map((permission, i) => (
                    <SubPermission key={permission.code}>
                        <FormField
                            control={control}
                            name={`userflags.${index}.permissions.${i}.allow_code`}
                            render={({ field }) => (
                                <FormItem>
                                    <FormControl>
                                        <CheckBoxAllowCode
                                            control={form.control}
                                            field={field}
                                            index4userflags={index}
                                            index4permissions={i}
                                            register={{
                                                ...form.register(`userflags.${index}.permissions.${i}.allow_code`, {
                                                    required: false,
                                                })
                                            }}
                                        />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>
                            )}
                        />
                        {permission.code}

                    </SubPermission>
                ))}
            </SubPermissionsContainer>)
        } else {
            return (<></>)
        }
    }
    const CheckBoxAllowCode = ({ control, field, index4userflags, index4permissions, register }) => {
        return (
            <Checkbox
                style={{ "marginLeft": "3px" }}
                checked={field.value === 1}
                onCheckedChange={(checked) => {
                    const allow_code = checked ? 1 : 0
                    const oUserflag = form.getValues(`userflags.${index4userflags}`)
                    let allow_flag = oUserflag.allow_flag
                    if (allow_code !== allow_flag) {
                        if (checked) {
                            let allCheck = true
                            oUserflag.permissions.forEach((permission, i) => {
                                if (i === index4permissions) { permission.allow_code = 1; }
                                allCheck = allCheck && (permission.allow_code === 1)
                            })
                            
                            allow_flag = allCheck ? 1 : 0
                        } else {
                            allow_flag = allow_code
                        }
                        
                        form.setValue(`userflags.${index4userflags}.allow_flag`, allow_flag)
					}

                    return field.onChange(allow_code)
                }}
            />
        )
    }

    const {
        fields: userflags
    } = useFieldArray({
        control: form.control,
        name: "userflags"
    });
    const onSubmit = (values) => {
        onFormFinish(values)
    }
    const onError = (e) => {
        console.log(thisJS, "onError", e)
    }

    useImperativeHandle(ref, () => {
        return {
            onFormSubmit: () => {
                formRef.current.requestSubmit();
            },
            setValue: (name, value, config) => {
                form.setValue(name, value, config)
            },
            setValues: (values) => {
                //console.log(thisJS, "setValues", values)
                if (typeof values === 'object') {
                    Object.keys(values).forEach((element) => {
                        form.setValue(element, values[element])
                    })
                }
            },
            getValues: (name) => {
                return form.getValues(name)
            },
        };
    }, []);

    return (
        <Form {...form}>
            <form ref={formRef} autoComplete="off" onSubmit={form.handleSubmit(onSubmit, onError)} >
                {
                    userflags.map((oUserflag, index) => {
                        return (
                            <PermissionGroupContainer key={oUserflag.bit}>
                                <MainPermission>
                                    <FormField
                                        control={form.control}
                                        name={`userflags.${index}.allow_flag`}
                                        render={({ field }) => (
                                            <FormItem>
                                                <FormControl>
                                                    <CheckBoxAllowFlag
                                                        control={form.control}
                                                        field={field}
                                                        index={index}
                                                        register={{
                                                            ...form.register(`userflags.${index}.allow_flag`, {
                                                                required: false,
                                                            })
                                                        }}
                                                    />
                                                </FormControl>
                                                <FormMessage />
                                            </FormItem>
                                        )}
                                    />
                                    <TitleContainer>
                                        <MainTitle>{ReactHtmlParser(oUserflag.flagdesc)}</MainTitle>
                                        <SubTitle>{oUserflag.flag}</SubTitle>
                                    </TitleContainer>
                                    <ToggleContainer>
                                        <FormField
                                            control={form.control}
                                            name={`userflags.${index}.expanded`}
                                            render={({ field }) => (
                                                <FormItem>
                                                    <FormControl>
                                                        <ButtonToggle
                                                            control={form.control}
                                                            field={field}
                                                            index={index}
                                                            register={{
                                                                ...form.register(`userflags.${index}.expanded`, {
                                                                    required: false,
                                                                })
                                                            }}
                                                        >
                                                        </ButtonToggle>
                                                    </FormControl>
                                                    <FormMessage />
                                                </FormItem>
                                            )}
                                        />
                                    </ToggleContainer>
                                </MainPermission>
                                <FormField
                                    control={form.control}
                                    name={`userflags.${index}.permissions`}
                                    render={({ field }) => (
                                        <FormItem>
                                            <FormControl>
                                                <SubPermissions
                                                    control={form.control}
                                                    field={field}
                                                    index={index}
                                                    register={{
                                                        ...form.register(`userflags.${index}.permissions`, {
                                                            required: false,
                                                        })
                                                    }}
                                                >
                                                </SubPermissions>
                                            </FormControl>
                                            <FormMessage />
                                        </FormItem>
                                    )}
                                />
                            </PermissionGroupContainer>
                        )
                    })
                }
            </form>
        </Form>
    )
})

const PermissionGroupContainer = styled.div`
    width: 100%;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-bottom: 1em;
    padding: 0.5em;
    box-sizing: border-box;
`;
const MainPermission = styled.div`
    display: flex;
    width: 100%;
    box-sizing: border-box;
`;
const TitleContainer = styled.div`
    display: flex;
`;
const MainTitle = styled.div`
    font-size: 1em;
    font-weight: bold;
`;
const SubTitle = styled.div`
    font-size: 0.8em;
    padding-top: 0.2em;
    padding-left: 0.5em;
`;
const ToggleContainer = styled.div`
    display: flex;
    margin-left: auto;
`;

const SubPermissionsContainer = styled.div`
    margin-top: 0.5em;
    padding-left: 1.5em;
    box-sizing: border-box;
    text-align: left;
`;

const SubPermission = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 0.5em;
    text-align: left;
`;

export default PatronPermissionForm